import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PatientInfoShared } from '../fragments';

export default gql`
  mutation createPatient($input: PatientCreateInput!) {
    createPatient(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      patient {
        ...PatientInfoShared
      }
    }
  }
  ${PatientInfoShared}
  ${ErrorMessageInfo}
`;
